import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html } from '../../utility/lit-entity';
import '../../common/bn-flash';
import '../props/role-selector';
import { sharedStyles } from '../../styles/shared-styles';

class ChangeUserRole extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      roleSelectorEntity: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html``;
    }
    const changeRoleActionHref = this.entity.getAction('begin-change-role').href;
    const disableSubmit = !this.roleSelectorEntity?.hasAction('change-role');
    return html`
      <form @submit="${this._submit}">
        <bn-flash></bn-flash>

        <role-selector .href="${changeRoleActionHref}" @role-selector-updated="${(e) => this._onRoleSelectorUpdate(e)}"></role-selector>

        <div class="form-actions">
          <button class="button button--contained" ?disabled="${disableSubmit}" type="submit">Set Role</button>
        </div>
      </form>
    `;
  }

  _onRoleSelectorUpdate(e) {
    this.roleSelectorEntity = e.detail.entity;
  }

  async _submit(e) {
    e.preventDefault();
    const action = this.roleSelectorEntity.getActionByName('change-role');
    if (!action) {
      return;
    }
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    try {
      const { entity } = await this.submitAction(action);
      entityStore.invalidateHref(this.href);
      this.dispatchEvent(new CustomEvent('role-set', { detail: entity, bubbles: true, composed: true }));
    } catch (error) {
      flash.critical(html`Could not change user's role.<br/><code>${error.message}</code>`);
    }
  }
}

window.customElements.define('change-user-role', ChangeUserRole);
